import $ from 'jquery';
import Cookies from 'js-cookie';
window.$ = window.jQuery = $;

function productReveal(){
	
	if ($(".products.products-reveal").length > 0){
		
		productRevealHeight();
		
		$(".products.products-reveal").each(function(){
			
			var reveal = this;
			
			$('.btn.products-reveal-show-all',reveal).click(function(){
				
				if ($("img.lazy_reveal",reveal).length > 0){
					$(function() {
						$('.lazy_reveal',reveal).Lazy();
					});
				}
				
				$(reveal).css('height','auto');
				$(reveal).removeClass('product-reveal-hide');
				$(reveal).addClass('product-reveal-show');
				
			});
				
		});
		
	}
	
}

function productRevealHeight(){
		
	$(".products.products-reveal").each(function(){
		
		var reveal = this;
		
		//get product sizing info
		var product_reveal_width = $(reveal).width();
		var product_thumbnail_height = $('.product', reveal).first().height();
		var product_thumbnail_width = $('.product', reveal).first().outerWidth();
		
		//how many products should be in view and how many products are there all together
		var products_in_view = Math.floor(product_reveal_width/product_thumbnail_width)*2;
		var total_products = $(reveal).attr('data-product-count');
		
		if($(reveal).hasClass('products-completes')) {
			console.log(products_in_view);
			console.log(total_products);
		}
		
		if(total_products > products_in_view && !$(reveal).hasClass('product-reveal-show')) {
			
			$(reveal).addClass('product-reveal-hide');
			
			$(reveal).children().slice(0,products_in_view).each(function(){
				$('.thumbnail img',this).removeClass('lazy_reveal');
				$('.thumbnail img',this).addClass('lazy_reveal_preview');
			});
			
			$(function() {
				$('.lazy_reveal_preview',reveal).Lazy();
			});
		
			var row_teaser_height = Math.floor(product_thumbnail_height + product_thumbnail_height *.7);
			$(reveal).attr('data-teaser-height',row_teaser_height);
			$(reveal).height(row_teaser_height);
			
		}
		
		if(total_products <= products_in_view) {
			
			$(reveal).css('height','auto');
			$(reveal).removeClass('product-reveal-hide');
			$(function() {
				$('.lazy_reveal',reveal).Lazy();
			});
			
		}
		
	});
	
}

$(document).ready(productReveal);
$(window).resize(productRevealHeight); 